import { z } from 'zod';
import { createApiResponseSchema } from '../../apiResponse';

const mergeUserDataDataSchema = z.object({
  merged: z.literal(true),
});

export const mergeUserDataResponseSchema = createApiResponseSchema(mergeUserDataDataSchema);

export type IMergeUserDataResponse = z.infer<typeof mergeUserDataResponseSchema>;
